export const GET_POSTS = "GET_POSTS";
export const GET_POST_BY_ID = "GET_POST_BY_ID";
export const UPDATE_POST = "UPDATE_POST";
export const DELETE_POST = "DELETE_POST";
export const CREATE_POST = "CREATE_POST";
